import { Component } from "react";
import api from "../../services/api";
import programSwitchService from "../../services/programSwitchService";
import { withRouter } from '../../common/with-router';
import {Card, Row, Col, Modal, Form, Button, Spinner, Alert} from "react-bootstrap";
import { tiposAcesso, getCurrentUser, objMeses, decryptData, encryptData, hasPerm } from '../../common/utils';
import logomarca from '../../assets/images/logo-hns.png';
import Cookies from 'js-cookie';
import dashboardComponentMap from '../../components/Dashboards/ChartComponents/';
import insideSalesDashboardMap from '../../components/InsideSales/Dashboards/';
import DashboardErrorBoundary from '../../components/InsideSales/Dashboards/DashboardErrorBoundary';
import AsyncSelect from 'react-select/async';
import { FaChartLine, FaChartBar, FaChevronDown, FaExclamationTriangle } from "react-icons/fa";

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: Object,
            exibirModalTipoAcesso: false,
            tipoAcesso: '',
            exibirModalOperador: false,
            exibirModalPrestador: false,
            exibirModalGestor: false,
            nomenclaturaPrograma: '', // nomenclatura do "escolher programa" (ex.: Chiesi = "Patologia")
            logoPreSelecao: '', // logo exibida enquanto o medico ainda nao escolheu o programa (1o vinculado)
            logoPreSelecaoCarregando: false, // true enquanto busca a logo do programa (medico) — evita piscar HNS
            loadingAmbiente: false,
            operador_id: '',
            prestador_id: '',
            gestor_id: '',
            beneficiario_id: '',
            clientes: [],
            clienteSelecionadoId: '',
            programas: [],
            programaSelecionadoId: '',
            programaSelecionadoCorFundo: '',
            programaSelecionadoCorPrimaria: '',
            programaSelecionadoCorSecundaria: '',
            carteiras: [],
            carteiraSelecionadaId: '',
            prestadorCategoria: '',
            atendimentos_medicos_mes: [],
            atendimentos_ano: [],
            atendimentos_laboratorios_mes: [],
            atendimentos_cidades_mes: [],
            list_titulos_graficos: {},
            graficosDashboard: [],
            loadingDashboardsConfig: true,
            programaId: null,
            isInsideSales: false,
            dashboard: {},
            dadosProgramaFallback: false,
            programaNome: null,
            programasSuperuserDisponiveis: [],
            loadingProgramasSuperuser: false,
            superuserSemPrograma: false,
        };
    }

    checkTermosPendentes = async () => {
        try {
            const response = await api.get('/termos-plataforma/termos-pendentes/');

            if (response.data && response.data.length > 0) {
                this.setState({
                    termosPendentes: response.data,
                    showTermosModal: true,
                    loadingTermos: false,
                });
            } else {
                this.setState({ loadingTermos: false }, () => {
                    this.loadOriginalComponentDidMount();
                });
            }
        } catch (error) {
            console.error("Erro ao verificar termos pendentes:", error);
            // Em caso de erro (ex: 401), deslogamos
            this.handleTermosRecusados();
        }
    };

    componentDidMount() {
        const dados_usuario = getCurrentUser();
        const dados_outros = decryptData('o');

        this.logoTimeout = setTimeout(() => {
            this.setState({ dadosProgramaFallback: true });
        }, 1000);

        // Trava de seguranca: se por algum motivo a logo do programa nao resolver, libera a exibicao
        // depois de 6s pra nao deixar o spinner preso (o caminho normal limpa isso bem antes).
        this.logoPreSelecaoTimeout = setTimeout(() => {
            this.setState({ logoPreSelecaoCarregando: false });
        }, 6000);

        const tipos_acesso = tiposAcesso();
        let perfil_gestor_industria = false;
        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor
                && tipos_acesso.gestor.tipo_gestor == 'industria') {
                perfil_gestor_industria = true;
            }
        }

        const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${dados_usuario['ambiente_programa_id']}`);

        // O gestor de industria tambem carrega os dashboards do programa. Antes ele era
        // excluido porque se assumia que todo gestor de industria ia direto para a tela de
        // Cod Veeva - o que so vale para quem tem essa tela habilitada no programa.
        if (dados_outros?.acesso_liberado === true && (dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'operador' || dados_usuario.tipo_usuario === 'gestor')) {
            const currentProgramaId = dados_usuario?.ambiente_programa_id;

            if (dados_usuario.is_superuser && !currentProgramaId) {
                this.setState({
                    superuserSemPrograma: true,
                    loadingDashboardsConfig: false
                });
            } else if (currentProgramaId) {
                this.setState({ programaId: currentProgramaId }, () => {
                    this.getDashboardsProgramaConfig();
                });
            } else {
                this.setState({ loadingDashboardsConfig: false });
                this.props.router.navigate("/atendimentos");
            }
        } else {
             this.setState({ loadingDashboardsConfig: false });
        }

        if(dados_usuario['tipo_usuario'] == 'prestador' && dados_outros['acesso_liberado'] === true) {

            if(dados_usuario['prestador_categoria'] === 'medicos') {
                const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                    return;
                } else {
                    if(hasPerm('add_atendimentos') && cachedPogramaTipo !== 'medimentor') {
                        //window.location.href = '/atendimentos';
                        window.location.href = '/agendamentos';
                        return;
                    } else {
                        window.location.href = '/agendamentos';
                        return;
                    }
                }
            }

            this.checkDashboardAndRedirect(dados_usuario);
        } else {
            if(dados_usuario['tipo_usuario'] == 'beneficiario'
                && dados_outros['acesso_liberado'] === true) {
                window.location.href = '/agendamentos/';
                return;
            }
        }

        // A tela de Cod Veeva pertence a um programa especifico, e o menu ja respeita a flag
        // habilitar_tela_cod_veeva. O redirecionamento nao respeitava: mandava para la todo
        // gestor de industria com a permissao, inclusive de outros clientes.
        const habilitaCodVeeva = localStorage.getItem(`programa_habilitar_tela_cod_veeva_${dados_usuario['ambiente_programa_id']}`) === 'sim';

        if(dados_outros['acesso_liberado'] === true && dados_usuario['tipo_usuario'] === 'gestor' && hasPerm('view_ultracarePspAtendimentosCompleto') && perfil_gestor_industria && habilitaCodVeeva) {
            window.location.href = '/codveeva/';
            return;
        }

        let definir_acesso = new URLSearchParams(this.props.router.location.search).get("definir_acesso");

        if(definir_acesso == 1) {
            this.setState({
                exibirModalTipoAcesso: true,
            });
        } else if (dados_outros && dados_outros['acesso_liberado'] === false) {
            const tipos_acesso = tiposAcesso();
            const primeiraChave = Object.keys(tipos_acesso)[0];

            if (primeiraChave) {
                this.setState({
                    tipoAcesso: primeiraChave,
                    operador_id: tipos_acesso[primeiraChave]['operador_id'],
                    gestor_id: tipos_acesso[primeiraChave]['gestor_id'],
                    prestador_id: tipos_acesso[primeiraChave]['prestador_id'],
                    beneficiario_id: tipos_acesso[primeiraChave]['beneficiario_id'],
                    // Prestador na pre-selecao: ja entra "carregando logo" pra nao piscar o HNS antes
                    // de getClientesPrestador buscar a logo do programa.
                    logoPreSelecaoCarregando: !!tipos_acesso[primeiraChave]['prestador_id'],
                }, () => {
                    if(dados_outros) {
                        dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                        dados_outros['operador_id'] = this.state.operador_id;
                        dados_outros['gestor_id'] = this.state.gestor_id;
                        dados_outros['prestador_id'] = this.state.prestador_id;
                        dados_outros['beneficiario_id'] = this.state.beneficiario_id;
                        encryptData('o', dados_outros);
                    }

                    // Abre o modal de seleção de ambiente
                    if(dados_outros['acesso_liberado'] === false) {
                        this.setState({loadingAmbiente: true});
                        this.modalEscolhaAmbiente();
                    }
                });
            }
        }
    }

    async getDashboardsProgramaConfig() {
        const { navigate } = this.props.router;

        this.setState({ loadingDashboardsConfig: true });
        let programaId = this.state.programaId;

        try {
            if (!programaId) {
                console.warn('Programa ID ausente. Redirecionando para /agendamentos.');
                this.setState({ loadingDashboardsConfig: false });
                navigate("/agendamentos");
                return;
            }

            const cachedConfig = localStorage.getItem(`programa_configuracoes_${programaId}`);
            const cachedTimestamp = localStorage.getItem(`programa_configuracoes_timestamp_${programaId}`);
            const cachedSlug = localStorage.getItem(`programa_tipo_slug_${programaId}`);
            const currentTime = new Date().getTime();
            const expirationTime = 1 * 60 * 60 * 1000; // 1 hora

            let configuracoes;
            let tipoSlug = cachedSlug || '';

            if (cachedConfig && cachedTimestamp && (currentTime - cachedTimestamp < expirationTime)) {
                try {
                    configuracoes = JSON.parse(cachedConfig);
                } catch (e) {
                    console.error("Erro ao parsear config do localStorage", e);
                    localStorage.removeItem(`programa_configuracoes_${programaId}`);
                    localStorage.removeItem(`programa_configuracoes_timestamp_${programaId}`);
                }
            }

            if (!configuracoes) {
                const response = await api.get(`/programas/${programaId}/`);
                configuracoes = response.data.configuracoes || {};

                tipoSlug = response.data.dados_tipo ? response.data.dados_tipo.slug : '';

                localStorage.setItem(`programa_configuracoes_${programaId}`, JSON.stringify(configuracoes));
                localStorage.setItem(`programa_configuracoes_timestamp_${programaId}`, new Date().getTime());
                localStorage.setItem(`programa_tipo_slug_${programaId}`, tipoSlug);

                window.dispatchEvent(new Event("programa_configuracoes_carregadas"));
            }

            const graficosDashboard = configuracoes.graficos_dashboard || [];

            const isInsideSales = tipoSlug === 'inside-sales';

            if (graficosDashboard.length === 0) {
                console.warn('Nenhum dashboard configurado. Redirecionando para /atendimentos.');
                this.setState({ loadingDashboardsConfig: false });
                navigate("/agendamentos");
                return;
            }

            this.setState({
                graficosDashboard,
                isInsideSales,
                loadingDashboardsConfig: false
            });

        } catch (error) {
            console.error('Erro ao buscar configurações de dashboards do programa:', error);
            this.setState({ loadingDashboardsConfig: false, graficosDashboard: [] });
            navigate("/agendamentos");
        }
    }

    buscarProgramasComDashboards = async (inputValue = '') => {

        try {
            // Adiciona o parâmetro de busca à API
            const response = await api.get(`/programas/?nome=${inputValue}&limit=500`);

            const programasComDashboard = response.data.results.filter(
                programa => {
                    const hasGraficos = programa.configuracoes?.graficos_dashboard?.length > 0;
                    if (hasGraficos) {
                    }
                    return hasGraficos;
                }
            );


            const opcoes = programasComDashboard.map(programa => ({
                value: programa.id,
                label: programa.nome,
            }));

            return opcoes;
        } catch (error) {
            console.error('[SUPERUSER] Erro ao buscar programas:', error);
            return [];
        }
    };

    // Métodos auxiliares para saudação e data
    getSaudacao = () => {
        const hora = new Date().getHours();
        if (hora >= 5 && hora < 12) return 'Bom dia';
        if (hora >= 12 && hora < 18) return 'Boa tarde';
        return 'Boa noite';
    };

    getNomeUsuario = () => {
        const dados = getCurrentUser();
        if (dados.name) {
            return dados.name;
        }
        return dados.username || 'Usuário';
    };

    getDataFormatada = () => {
        const diasSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const hoje = new Date();
        const diaSemana = diasSemana[hoje.getDay()];
        const dia = hoje.getDate();
        const mes = meses[hoje.getMonth()];
        const ano = hoje.getFullYear();

        return `${diaSemana}, ${dia} de ${mes} de ${ano}`;
    };

    handleProgramaSuperuserChange = async (selectedOption) => {
        if (!selectedOption || !selectedOption.value) return;

        const programaId = parseInt(selectedOption.value);
        const programaNome = selectedOption.label;

        if (isNaN(programaId)) return;

        // Atualiza state primeiro
        this.setState({
            programaId,
            programaNome,
            loadingDashboardsConfig: true
            // NÃO muda superuserSemPrograma - mantém seletor visível
        });

        // Chama diretamente com o programaId
        const { navigate } = this.props.router;

        try {

            const cachedConfig = localStorage.getItem(`programa_configuracoes_${programaId}`);
            const cachedTimestamp = localStorage.getItem(`programa_configuracoes_timestamp_${programaId}`);
            const currentTime = new Date().getTime();
            const expirationTime = 1 * 60 * 60 * 1000; // 1 hora

            let configuracoes;

            if (cachedConfig && cachedTimestamp && (currentTime - cachedTimestamp < expirationTime)) {
                try {
                    configuracoes = JSON.parse(cachedConfig);
                } catch (e) {
                    console.error("Erro ao parsear config do localStorage", e);
                    localStorage.removeItem(`programa_configuracoes_${programaId}`);
                    localStorage.removeItem(`programa_configuracoes_timestamp_${programaId}`);
                }
            }

            // Se não encontrou no cache, busca na API
            if (!configuracoes) {
                const response = await api.get(`/programas/${programaId}/`);
                configuracoes = response.data.configuracoes || {};

                localStorage.setItem(`programa_configuracoes_${programaId}`, JSON.stringify(configuracoes));
                localStorage.setItem(`programa_configuracoes_timestamp_${programaId}`, new Date().getTime());

                window.dispatchEvent(new Event("programa_configuracoes_carregadas"));
            }

            const graficosDashboard = configuracoes.graficos_dashboard || [];


            // Para superuser, NUNCA redireciona, sempre tenta mostrar os dashboards
            this.setState({ graficosDashboard, loadingDashboardsConfig: false });

        } catch (error) {
            console.error('[SUPERUSER] Erro ao buscar configurações de dashboards do programa:', error);
            this.setState({ loadingDashboardsConfig: false, graficosDashboard: [] });
        }
    };


    renderDashboards = () => {
        const { graficosDashboard, programaId, superuserSemPrograma, programaNome, isInsideSales } = this.state;

        if (!graficosDashboard || graficosDashboard.length === 0) {
            if(!programaId) {
                return;
            } else {
                return (
                    <Col lg={12}>
                        <Card className="cardDestaque text-center p-5">
                            <Card.Body>
                                <h6>Nenhum dashboard configurado para este programa.</h6>
                            </Card.Body>
                        </Card>
                    </Col>
                );
            }
        }

        const activeDashboardMap = isInsideSales ? insideSalesDashboardMap : dashboardComponentMap;

        // Se for Inside Sales e tiver inside_sales_full, renderiza apenas ele (dashboard completo)
        if (isInsideSales && graficosDashboard.includes("inside_sales_full")) {
            const FullDashboard = activeDashboardMap["inside_sales_full"];
            if (FullDashboard) {
                return (
                    <Col sm={12} lg={12} className="p-0">
                        <DashboardErrorBoundary label="inside_sales_full">
                            <FullDashboard programaId={programaId} />
                        </DashboardErrorBoundary>
                    </Col>
                );
            }
        }

        // Configuração de seções para Inside Sales
        const insideSalesSections = {
            "inside_sales_cadastro_medicos": { title: "1. Cadastro de Médicos", subtitle: "Evolução mensal e status de opt-in" },
            "inside_sales_resumo_visitas": { title: "2. Resumo de Visitas", subtitle: "Volume, distribuição mensal e revisitas" },
            "inside_sales_ocorrencias": { title: "3. Registro de Ocorrências", subtitle: "Tentativas de contato sem retorno" },
            "inside_sales_dados_relevantes": { title: "4. Dados Relevantes", subtitle: "Análise das informações coletadas" },
            "inside_sales_visitas_contato": { title: "5. Visitas e Via de Contato", subtitle: "Canais e período de visitas" },
            "inside_sales_base_origem": { title: "6. Base de Médicos", subtitle: "Status e origem dos visitados" },
            "inside_sales_geografico": { title: "7. Distribuição Geográfica", subtitle: "Mapa e especialidades médicas" },
            "inside_sales_metas": { title: "8. Projeções e Metas", subtitle: "Quadro de metas e gráfico de projeção" },
        };

        // Ordena cards_status_detail primeiro (para outros programas)
        const orderedDashboards = [
            ...graficosDashboard.filter((g) => g === "cards_status_detail"),
            ...graficosDashboard.filter((g) => g !== "cards_status_detail" && g !== "inside_sales_full"),
        ];

        return orderedDashboards.map((graficoKey) => {
            const DashboardComponent = activeDashboardMap[graficoKey];

            if (!DashboardComponent) {
                return null;
            }

            // Para Inside Sales, renderiza com seção
            if (isInsideSales && insideSalesSections[graficoKey]) {
                const section = insideSalesSections[graficoKey];
                return (
                    <Col sm={12} lg={12} className="mb-2" key={graficoKey}>
                        {/* Section Divider */}
                        <div className="row mt-4 mb-3">
                            <div className="col-12">
                                <div className="p-3 bg-white shadow-sm rounded border-start border-5 border-primary">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="fw-bold text-dark m-0">{section.title}</h5>
                                            <small className="text-muted">{section.subtitle}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Dashboard Component */}
                        <DashboardErrorBoundary label={graficoKey}>
                            <DashboardComponent programaId={programaId} />
                        </DashboardErrorBoundary>
                    </Col>
                );
            }

            // Para outros programas, mantém layout original.
            // Painéis consolidados (vários gráficos em um bloco) ocupam a linha inteira;
            // os gráficos avulsos seguem lado a lado.
            const dashboardsLarguraCheia = ["cards_status_detail", "conecta_pku_dashboard", "conecta_pku_tratamento_dashboard"];
            const colSize = dashboardsLarguraCheia.includes(graficoKey) ? 12 : 6;

            return (
            <Col sm={12} lg={colSize} className="mb-4" key={graficoKey}>
                <DashboardErrorBoundary label={graficoKey}>
                    <DashboardComponent programaId={programaId} nomePrograma={programaNome} />
                </DashboardErrorBoundary>
            </Col>
            );
        });
    };


    modalEscolhaAmbiente = () => {
        const { tipoAcesso } = this.state;

        switch (tipoAcesso) {
            case "operador":
                this.getCarteirasOperador();

                this.setState({ exibirModalOperador: true, loadingAmbiente: false });
                break;
            case "prestador":
                this.getClientesPrestador();

                break;
            case "gestor":
                this.getClientesGestor();

                this.setState({ exibirModalGestor: true, loadingAmbiente: false });
                break;
            case "beneficiario":
                this.acessoBeneficiario();
                break;
            default:
                // Caso não seja nenhum dos tipos acima, não fazer nada ou tratar conforme necessário
                break;
        }
    }

    acessoBeneficiario = () => {
        let dados_outros = decryptData('o');

        if (dados_outros) {
            dados_outros['tipo_usuario'] = 'beneficiario';
            dados_outros['beneficiario_id'] = this.state.beneficiario_id;
            dados_outros['ambiente_cliente_id'] = '10';
            dados_outros['ambiente_programa_id'] = '8';
            dados_outros['acesso_liberado'] = true;
            encryptData('o', dados_outros);
        }

        this.setState({ loadingAmbiente: true }, () => {
            setTimeout(() => {
                this.props.router.navigate("/agendamentos");
                window.location.reload();
            }, 200);
        });
    }

    checkDashboardAndRedirect = async (dados_usuario) => {
        const programaId = dados_usuario.ambiente_programa_id;
        if (programaId) {
            // 1) aguarda o array de dashboards
            const dashboard = await this.getDashboard(programaId);

            if (dashboard.length > 0) {
                this.setState({
                    dashboard: dashboard
                }, () => {
                    if (dados_usuario?.prestador_categoria === 'medicos' && hasPerm('view_exames')) {
                        this.getExamesMedico();
                    }
                });
                return;
            } else {
                if(dados_usuario['ambiente_programa_id'] === 35 || dados_usuario['ambiente_programa_id'] === 11) {
                    window.location.href = '/agendas/';
                    return;
                } else {
                    if (hasPerm('add_atendimentos')) {
                        window.location.href = '/atendimentos/';
                    } else {
                        window.location.href = '/agendamentos/';
                    }
                    return;
                }
            }
        }

        // caso não tenha ambiente_programa_id
        if (hasPerm('add_atendimentos')) {
            window.location.href = '/atendimentos/';
        } else {
            window.location.href = '/agendamentos/';
        }
        return;
    }

    getDashboard = async (programa_id) => {
        try {
            const response = await api.get(`/programas/dashboard/?programa_id=${programa_id}`);
            return response.data.results;
        } catch (error) {
            console.error('Não foi possível carregar dashboard', error);
            return [];
        }
    }

    getClientesGestor = async () => {
        try {
            const response = await api.get(`/pessoas/clientes/?tipo_usuario=gestor`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));

            const programasResponse = await api.get(`/pessoas/gestores/programas/?gestor_id=${this.state.gestor_id}`);
            const programas = programasResponse.data.results;

            if (programas.length === 1) {
                const programa = programas[0];
                const clienteId = opcoes[0].value;

                let dados_outros = decryptData('o');

                if (dados_outros) {
                    dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                    dados_outros['gestor_id'] = this.state.gestor_id;
                    dados_outros['ambiente_cliente_id'] = clienteId;
                    dados_outros['ambiente_programa_id'] = programa.programa_id;
                    dados_outros['acesso_liberado'] = true;
                    encryptData('o', dados_outros);
                }

                this.setState({ loadingAmbiente: true }, () => {
                    setTimeout(() => {
                        this.props.router.navigate("/");
                        window.location.reload();
                    }, 200);
                });

            } else {
                this.setState({
                    clientes: opcoes
                }, () => {
                    this.setState({ exibirModalGestor: true, loadingAmbiente: false });
                })
            }
        } catch (error) {
            console.error('Erro ao carregar clientes do gestor:', error);
            return [];
        }
    }

    getClientesPrestador = async () => {
        try {
            const response = await api.get(`/pessoas/prestadores/${this.state.prestador_id}/`);
            if(response.data) {
                const prestador = response.data;

                const categoriaPrestador = prestador.categoria;

                // Se categoria for medicos a gente deixa passar
                if(categoriaPrestador === 'medicos') {
                    const programasResponse = await api.get(`/programas/prestadores/?prestador_id=${this.state.prestador_id}`);
                    const programas = programasResponse.data.results;

                    if (programas.length === 1) {
                        const programa = programas[0];

                        let dados_outros = decryptData('o');

                        if (dados_outros) {
                            dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                            dados_outros['prestador_id'] = this.state.prestador_id;
                            dados_outros['prestador_categoria'] = categoriaPrestador;
                            dados_outros['ambiente_cliente_id'] = programa.cliente_id;
                            dados_outros['ambiente_programa_id'] = programa.programa_id;
                            dados_outros['acesso_liberado'] = true;
                            encryptData('o', dados_outros);
                        }

                        this.setState({ loadingAmbiente: true }, () => {
                            setTimeout(() => {
                                this.props.router.navigate("/");
                                window.location.reload();
                            }, 200);
                        });
                    } else {
                        // Médico com vários programas: abre o modal de escolha (como os demais
                        // prestadores), em vez de entrar sem programa selecionado. A confirmação usa
                        // SSO (tipo_cadastro_medico 'cliente') em enviarAmbienteMedico.
                        const programasMap = new Map();
                        programas.forEach((programa) => {
                            if (!programasMap.has(programa.programa_id)) {
                                const nomeCliente = programa.dados_cliente?.nome_fantasia || programa.dados_cliente?.nome || programa.dados_cliente?.razao_social || '';
                                programasMap.set(programa.programa_id, {
                                    value: programa.programa_id,
                                    label: programa.dados_programa?.nome || 'Programa sem nome',
                                    uuid: programa.dados_programa?.uuid,
                                    tipo_cadastro_medico: programa.dados_programa?.tipo_cadastro_medico,
                                    cliente_id: programa.cliente_id,
                                    nome_cliente: nomeCliente,
                                    cor_fundo: programa.dados_programa?.layout_cor_fundo || '',
                                    cor_primaria: programa.dados_programa?.layout_cor_primaria || '',
                                    cor_secundaria: programa.dados_programa?.layout_cor_secundaria || '',
                                });
                            }
                        });

                        this.setState({
                            programas: Array.from(programasMap.values()),
                            prestadorCategoria: categoriaPrestador,
                            clienteSelecionadoId: '',
                            programaSelecionadoId: '',
                            exibirModalPrestador: true,
                            loadingAmbiente: false
                        });

                        // Nomenclatura do "escolher programa" (ex.: Chiesi quer "Patologia") — lida do
                        // programa principal do médico, sem bloquear a exibição do modal.
                        const primeiroProgramaId = Array.from(programasMap.values())[0]?.value;
                        if (primeiroProgramaId) {
                            api.get(`/programas/${primeiroProgramaId}/`)
                                .then(resp => {
                                    const nom = resp.data?.configuracoes?.nomenclatura_escolha_programa;
                                    if (nom) this.setState({ nomenclaturaPrograma: nom });
                                    // Logo exibida enquanto escolhe o programa (ex.: Chiesi -> Cuidados Raros)
                                    if (resp.data?.imagem) this.setState({ logoPreSelecao: resp.data.imagem });
                                })
                                .catch(() => {})
                                // Logo resolvida (com ou sem imagem): libera a exibicao.
                                .finally(() => this.setState({ logoPreSelecaoCarregando: false }));
                        } else {
                            this.setState({ logoPreSelecaoCarregando: false });
                        }
                    }
                    return;
                }

                // Nao-medico nao usa a logo de pre-selecao do programa: libera a exibicao (cai no HNS).
                this.setState({ logoPreSelecaoCarregando: false });

                // PRESTADORES NÃO-MÉDICOS: Fluxo de seleção de cliente
                //Se tiver acesso exclusivo de programa
                if(prestador.cliente_id && prestador.programa_cadastro_uuid && prestador.dados_programa?.uuid) {
                    this.setState({
                        clienteSelecionadoId: prestador.cliente_id
                    }, () => {
                        const programa_uuid = prestador.dados_programa.uuid;

                        //consulta programa
                        api.get(`/programas/${programa_uuid}/`)
                        .then(responseProg => {
                            const programa = responseProg.data;

                            this.setState({
                                programaSelecionadoId: programa.id,
                                programaSelecionadoCorFundo: programa.layout_cor_fundo,
                                programaSelecionadoCorPrimaria: programa.layout_cor_primaria,
                                programaSelecionadoCorSecundaria: programa.layout_cor_secundaria,
                            }, () => {

                                let dados_user = getCurrentUser();

                                dados_user['ambiente_programa_cor_fundo'] = this.state.programaSelecionadoCorFundo;
                                dados_user['ambiente_programa_cor_primaria'] = this.state.programaSelecionadoCorPrimaria;
                                dados_user['ambiente_programa_cor_secundaria'] = this.state.programaSelecionadoCorSecundaria;

                                // Armazena os dados no cookie
                                const isHttps = window.location.protocol === 'https:';
                                Cookies.set("user", JSON.stringify(dados_user), { secure: isHttps, sameSite: 'Strict', path: '/' });

                                //Libera acesso
                                let dados_outros = decryptData('o');
                                if (dados_outros) {
                                    dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                                    dados_outros['prestador_id'] = this.state.prestador_id;
                                    dados_outros['ambiente_cliente_id'] = this.state.clienteSelecionadoId;
                                    dados_outros['ambiente_programa_id'] = this.state.programaSelecionadoId;
                                    dados_outros['prestador_categoria'] = categoriaPrestador;
                                    dados_outros['acesso_liberado'] = true;
                                    encryptData('o', dados_outros);
                                }

                                this.setState({ loadingAmbiente: true }, () => {
                                    setTimeout(() => {
                                        this.props.router.navigate("/");
                                        window.location.reload();
                                    }, 200);
                                });

                            })
                        })
                        .catch(error => {
                            console.error('Erro ao carregar dados do programa atual:', error);
                            Sentry.captureException('Erro ao carregar dados do programa atual:', error);
                        });
                    })
                } else {
                    const programasResponse = await api.get(`/programas/prestadores/?prestador_id=${this.state.prestador_id}`);
                    const programas = programasResponse.data.results;

                    if (programas.length === 1) {
                        const programa = programas[0];

                        let dados_outros = decryptData('o');

                        if (dados_outros) {
                            dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                            dados_outros['prestador_id'] = this.state.prestador_id;
                            dados_outros['prestador_categoria'] = categoriaPrestador;
                            dados_outros['ambiente_cliente_id'] = programa.cliente_id;
                            dados_outros['ambiente_programa_id'] = programa.programa_id;
                            dados_outros['acesso_liberado'] = true;
                            encryptData('o', dados_outros);
                        }

                        this.setState({ loadingAmbiente: true }, () => {
                            setTimeout(() => {
                                this.props.router.navigate("/");
                                window.location.reload();
                            }, 200);
                        });

                    } else {
                        const programasMap = new Map();
                        programas.forEach((programa) => {
                            if (!programasMap.has(programa.programa_id)) {
                                const nomeCliente = programa.dados_cliente?.nome_fantasia || programa.dados_cliente?.nome || programa.dados_cliente?.razao_social || '';
                                const razaoSocial = programa.dados_cliente?.razao_social || '';
                                const nomeBaseCliente = razaoSocial && razaoSocial !== nomeCliente
                                    ? `${nomeCliente} (${razaoSocial})`
                                    : nomeCliente;

                                programasMap.set(programa.programa_id, {
                                    value: programa.programa_id,
                                    label: `${programa.dados_programa?.nome || 'Programa sem nome'} | ${nomeBaseCliente || '-'}`,
                                    cliente_id: programa.cliente_id,
                                    cor_fundo: programa.dados_programa?.layout_cor_fundo || '',
                                    cor_primaria: programa.dados_programa?.layout_cor_primaria || '',
                                    cor_secundaria: programa.dados_programa?.layout_cor_secundaria || '',
                                });
                            }
                        });

                        this.setState({
                            programas: Array.from(programasMap.values()),
                            clienteSelecionadoId: '',
                            programaSelecionadoId: '',
                            exibirModalPrestador: true,
                            loadingAmbiente: false
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Erro ao carregar dados do prestador:', error);
            return [];
        }
    }

    getCarteirasOperador = async () => {
        try {
            const response = await api.get(`/pessoas/operadores/carteiras/?tipo_usuario=operador`);
            const opcoes = response.data.results.map(carteira => ({
                value: carteira.carteira_id,
                label: carteira.dados_carteira.nome
            }));
            this.setState({
                carteiras: opcoes
            })

            if(Number(opcoes.length) == 1){
                this.setState({
                    carteiraSelecionadaId: opcoes[0].value
                })

                this.getProgramasOperador(opcoes[0].value)
            }
        } catch (error) {
            console.error('Erro ao carregar carteiras:', error);
            return [];
        }
    }

    getProgramasOperador = async (carteiraId) => {
        try {
            const response = await api.get(`/carteiras/programas/?carteira=${carteiraId}`);
            const opcoes = response.data.results.map(carteira => ({
                value: carteira.programa_id,
                label: `${carteira.dados_programa.nome} (${carteira.dados_cliente.nome_fantasia} - ${carteira.dados_cliente.razao_social})`,
                cliente_id: carteira.dados_cliente.id
            }));
            this.setState({
                programas: opcoes
            })

            if(Number(opcoes.length) == 1){
                this.setState({
                    programaSelecionadoId: opcoes[0].value
                })
                await this.getClientePrograma(opcoes[0].value)
                this.enviarAmbienteOperador();
            }
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    }

    getProgramasCliente = async (clienteId) => {
        const { tipoAcesso } = this.state;

        try {
            const response = await api.get(`/programas/?cliente_id=${clienteId}`);
            let programas = response.data.results;

            // O gestor pode estar vinculado a apenas alguns programas do cliente. Quando esse
            // vinculo existe ele manda: sem isso o gestor via todos os programas do cliente,
            // inclusive os que nao acompanha.
            if (tipoAcesso === 'gestor' && this.state.gestor_id) {
                try {
                    const vinculos = await api.get(`/pessoas/gestores/programas/?gestor_id=${this.state.gestor_id}`);
                    const permitidos = (vinculos.data.results || []).map(v => v.programa_id);
                    if (permitidos.length > 0) {
                        programas = programas.filter(p => permitidos.includes(p.id));
                    }
                } catch (e) {
                    console.warn('Nao foi possivel carregar os programas do gestor:', e);
                }
            }

            const opcoes = programas.map(programa => ({
                value: programa.id,
                label: programa.nome,
                cor_fundo: programa.layout_cor_fundo,
                cor_primaria: programa.layout_cor_primaria,
                cor_secundaria: programa.layout_cor_secundaria,
            }));

            if(opcoes.length === 1) {
                this.setState({
                    programaSelecionadoId: opcoes[0].value,
                    programaSelecionadoCorFundo: opcoes[0].cor_fundo,
                    programaSelecionadoCorPrimaria: opcoes[0].cor_primaria,
                    programaSelecionadoCorSecundaria: opcoes[0].cor_secundaria,
                }, () => {
                    if(tipoAcesso === 'prestador') {
                        this.enviarAmbientePrestador();
                    } else if(tipoAcesso === 'operador') {
                        this.enviarAmbienteOperador();
                    } else {
                        this.enviarAmbienteGestor();
                    }

                });
            } else {
                if(tipoAcesso === 'prestador') {
                    this.setState({ exibirModalPrestador: true, loadingAmbiente: false });
                } else if(tipoAcesso === 'operador') {
                    this.setState({ exibirModalOperador: true, loadingAmbiente: false });
                } else {
                    this.setState({ exibirModalGestor: true, loadingAmbiente: false });
                }
            }

            this.setState({
                programas: opcoes
            })
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    }

    getClientePrograma = async (programaId) => {
        try {
            const response = await api.get(`/programas/${programaId}`);

            if(response.data) {
                const programa = response.data;

                this.setState({
                    clienteSelecionadoId: programa.cliente_id
                })
            }
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    }

    getProgramasPrestadorPorCliente = async (clienteId) => {
        try {
            const response = await api.get(`/programas/prestadores/?prestador_id=${this.state.prestador_id}&cliente_id=${clienteId}`);
            const programas = response.data.results;

            const programasMap = new Map();
            programas.forEach(programa => {
                if (!programasMap.has(programa.programa_id)) {
                    programasMap.set(programa.programa_id, {
                        value: programa.programa_id,
                        label: programa.dados_programa.nome,
                        cor_fundo: programa.dados_programa.layout_cor_fundo,
                        cor_primaria: programa.dados_programa.layout_cor_primaria,
                        cor_secundaria: programa.dados_programa.layout_cor_secundaria,
                    });
                }
            });

            const opcoes = Array.from(programasMap.values());

            this.setState({
                programas: opcoes
            });

            // Se tiver apenas 1 programa, libera automaticamente
            if(opcoes.length === 1) {
                this.setState({
                    programaSelecionadoId: opcoes[0].value,
                    programaSelecionadoCorFundo: opcoes[0].cor_fundo,
                    programaSelecionadoCorPrimaria: opcoes[0].cor_primaria,
                    programaSelecionadoCorSecundaria: opcoes[0].cor_secundaria,
                }, () => {
                    this.enviarAmbientePrestador();
                });
            } else {
                // Múltiplos programas: exibir modal
                this.setState({
                    exibirModalPrestador: true,
                    loadingAmbiente: false
                });
            }
        } catch (error) {
            console.error('Erro ao carregar programas do prestador:', error);
            Sentry.captureException(error);
            return [];
        }
    }

    fecharModal = () => {
        this.setState({
            exibirModalTipoAcesso: false,
        });
    };

    fecharModalOperador = () => {
        this.setState({
            exibirModalOperador: false,
        });
    };

    fecharModalGestor = () => {
        this.setState({
            exibirModalGestor: false,
        });
    };

    fecharModalPrestador = () => {
        this.setState({
            exibirModalPrestador: false,
        });
    };


    alterarTipoAcesso = (e) => {
        const tipo_user = e.target.value;

        this.setState({
            tipoAcesso: e.target.value,
            operador_id: tiposAcesso()[tipo_user]['operador_id'],
            gestor_id: tiposAcesso()[tipo_user]['gestor_id'],
            prestador_id: tiposAcesso()[tipo_user]['prestador_id'],
        });
    }

    enviarTipoAcesso = () => {
        if(!this.state.tipoAcesso) {
            return;
        }

        let dados_outros = decryptData('o');

        if (dados_outros) {
            dados_outros['tipo_usuario'] = this.state.tipoAcesso;
            dados_outros['operador_id'] = this.state.operador_id;
            dados_outros['gestor_id'] = this.state.gestor_id;
            dados_outros['prestador_id'] = this.state.prestador_id;
            encryptData('o', dados_outros);
        }

       this.setState({ loadingAmbiente: true }, () => {
            setTimeout(() => {
                this.props.router.navigate("/");
                window.location.reload();
            }, 200);
        });

    }

    enviarAmbienteOperador = () => {
        if(!this.state.tipoAcesso || !this.state.carteiraSelecionadaId || !this.state.programaSelecionadoId || !this.state.clienteSelecionadoId) {
            return;
        }

        let dados_user = getCurrentUser();

        dados_user['ambiente_programa_cor_fundo'] = this.state.programaSelecionadoCorFundo;
        dados_user['ambiente_programa_cor_primaria'] = this.state.programaSelecionadoCorPrimaria;
        dados_user['ambiente_programa_cor_secundaria'] = this.state.programaSelecionadoCorSecundaria;

        // Armazena os dados no cookie
        const isHttps = window.location.protocol === 'https:';
        Cookies.set("user", JSON.stringify(dados_user), { secure: isHttps, sameSite: 'Strict', path: '/' });

        //Libera acesso
        let dados_outros = decryptData('o');
        if (dados_outros) {
            dados_outros['tipo_usuario'] = this.state.tipoAcesso;
            dados_outros['operador_id'] = this.state.operador_id;
            dados_outros['ambiente_cliente_id'] = this.state.clienteSelecionadoId;
            dados_outros['ambiente_programa_id'] = this.state.programaSelecionadoId;
            dados_outros['ambiente_carteira_id'] = this.state.carteiraSelecionadaId;
            dados_outros['acesso_liberado'] = true;
            encryptData('o', dados_outros);
        }

        this.setState({ loadingAmbiente: true }, () => {
            setTimeout(() => {
                this.props.router.navigate("/");
                window.location.reload();
            }, 200);
        });

    }

    enviarAmbienteGestor = () => {
        if(!this.state.tipoAcesso || !this.state.programaSelecionadoId || !this.state.clienteSelecionadoId) {
            return;
        }

        let dados_user = getCurrentUser();

        dados_user['ambiente_programa_cor_fundo'] = this.state.programaSelecionadoCorFundo;
        dados_user['ambiente_programa_cor_primaria'] = this.state.programaSelecionadoCorPrimaria;
        dados_user['ambiente_programa_cor_secundaria'] = this.state.programaSelecionadoCorSecundaria;

        // Armazena os dados no cookie
        const isHttps = window.location.protocol === 'https:';
        Cookies.set("user", JSON.stringify(dados_user), { secure: isHttps, sameSite: 'Strict', path: '/' });

        //Libera acesso
        let dados_outros = decryptData('o');
        if (dados_outros) {
            dados_outros['tipo_usuario'] = this.state.tipoAcesso;
            dados_outros['gestor_id'] = this.state.gestor_id;
            dados_outros['ambiente_cliente_id'] = this.state.clienteSelecionadoId;
            dados_outros['ambiente_programa_id'] = this.state.programaSelecionadoId;
            dados_outros['acesso_liberado'] = true;
            encryptData('o', dados_outros);
        }

        this.setState({ loadingAmbiente: true }, () => {
            setTimeout(() => {
                this.props.router.navigate("/");
                window.location.reload();
            }, 200);
        });

    }

    enviarAmbientePrestador = async () => {
        if(!this.state.tipoAcesso || !this.state.programaSelecionadoId || !this.state.clienteSelecionadoId) {
            return;
        }

        try {
            const response = await api.get(`/pessoas/prestadores/${this.state.prestador_id}`);
            const categoriaPrestador = response.data.categoria;

            let dados_user = getCurrentUser();

            dados_user['ambiente_programa_cor_fundo'] = this.state.programaSelecionadoCorFundo;
            dados_user['ambiente_programa_cor_primaria'] = this.state.programaSelecionadoCorPrimaria;
            dados_user['ambiente_programa_cor_secundaria'] = this.state.programaSelecionadoCorSecundaria;

            // Armazena os dados no cookie
            const isHttps = window.location.protocol === 'https:';
            Cookies.set("user", JSON.stringify(dados_user), { secure: isHttps, sameSite: 'Strict', path: '/' });

            //Libera acesso
            let dados_outros = decryptData('o');
            if (dados_outros) {
                dados_outros['tipo_usuario'] = this.state.tipoAcesso;
                dados_outros['prestador_id'] = this.state.prestador_id;
                dados_outros['ambiente_cliente_id'] = this.state.clienteSelecionadoId;
                dados_outros['ambiente_programa_id'] = this.state.programaSelecionadoId;
                dados_outros['prestador_categoria'] = categoriaPrestador;
                dados_outros['acesso_liberado'] = true;
                encryptData('o', dados_outros);
            }

            this.setState({ loadingAmbiente: true }, () => {
                setTimeout(() => {
                    this.props.router.navigate("/");
                    window.location.reload();
                }, 200);
            });

        } catch (error) {
            console.error('Erro ao obter detalhes do prestador:', error);
        }
    }

    // Confirma a escolha de programa do médico na home. Médico Chiesi tem tipo_cadastro_medico
    // 'cliente' → a troca exige SSO (mesmo fluxo do TopNavigation.alterarAmbiente). Médico fora
    // desse padrão cai no fluxo padrão de prestador.
    enviarAmbienteMedico = async () => {
        if (!this.state.programaSelecionadoId) {
            return;
        }

        const programa = this.state.programas.find(
            (p) => `${p.value}` === `${this.state.programaSelecionadoId}`
        );

        if (!programa) {
            return;
        }

        if (programa.tipo_cadastro_medico !== 'cliente') {
            this.enviarAmbientePrestador();
            return;
        }

        this.setState({ loadingAmbiente: true });

        try {
            const resp = await programSwitchService.performProgramSwitchSSO(
                { uuid: programa.uuid, nome: programa.label, id: programa.value },
                null
            );

            let dados_outros = decryptData('o');
            if (dados_outros) {
                dados_outros['tipo_usuario'] = 'prestador';
                dados_outros['prestador_id'] = this.state.prestador_id;
                dados_outros['prestador_categoria'] = 'medicos';
                dados_outros['ambiente_cliente_id'] = resp?.ambiente_cliente_id || programa.cliente_id;
                dados_outros['ambiente_programa_id'] = resp?.ambiente_programa_id || programa.value;
                dados_outros['acesso_liberado'] = true;
                encryptData('o', dados_outros);
            }

            setTimeout(() => {
                this.props.router.navigate("/");
                window.location.reload();
            }, 200);
        } catch (error) {
            console.error('Erro ao trocar de programa (médico):', error);
            this.setState({ loadingAmbiente: false });
        }
    }

    handleProgramaChange = (event) => {
        const programaId = event.target.value;
        const { tipoAcesso } = this.state;

        if (tipoAcesso === 'prestador') {
            const programaSelecionado = this.state.programas.find(p => p.value == programaId);

            if (programaSelecionado) {
                this.setState({
                    programaSelecionadoId: programaId,
                    programaSelecionadoCorFundo: programaSelecionado.cor_fundo,
                    programaSelecionadoCorPrimaria: programaSelecionado.cor_primaria,
                    programaSelecionadoCorSecundaria: programaSelecionado.cor_secundaria
                }, () => {
                    this.getClientePrograma(programaId);
                });
            }
        } else {
            const corFundo = event.target.cor_fundo;
            const corPrimaria = event.target.cor_primaria;
            const corSecundaria = event.target.cor_secundaria;

            this.setState({ programaSelecionadoId: programaId, programaSelecionadoCorFundo: corFundo, programaSelecionadoCorPrimaria: corPrimaria, programaSelecionadoCorSecundaria: corSecundaria }, () => {
                this.getClientePrograma(programaId);
            });
        }
    }

    handleCarteiraChange = (event) => {
        const carteiraId = event.target.value;

        this.setState({ carteiraSelecionadaId: carteiraId, clienteSelecionadoId: '', programaSelecionadoId: '', programaSelecionadoCorFundo: '', programaSelecionadoCorPrimaria: '', programaSelecionadoCorSecundaria: '', programas: [] }, () => {
            this.getProgramasOperador(carteiraId)
        });
    }

    handleClienteChange = (event) => {
        const clienteId = event.target.value;
        const { tipoAcesso } = this.state;

        this.setState({ clienteSelecionadoId: clienteId, programaSelecionadoId: '', programas: [] }, () => {
            if (tipoAcesso === 'prestador') {
                this.getProgramasPrestadorPorCliente(clienteId);
            } else {
                this.getProgramasCliente(clienteId);
            }
        });
    }

    handleProgramaClienteChange = (event) => {
        const programaId = event.target.value;
        const programaSelecionado = this.state.programas.find(
            (programa) => `${programa.value}` === `${programaId}`
        );

        const newState = {
            programaSelecionadoId: programaId,
            programaSelecionadoCorFundo: programaSelecionado?.cor_fundo || '',
            programaSelecionadoCorPrimaria: programaSelecionado?.cor_primaria || '',
            programaSelecionadoCorSecundaria: programaSelecionado?.cor_secundaria || '',
        };

        // Só sobrescreve clienteSelecionadoId no fluxo de prestador
        if (this.state.tipoAcesso === 'prestador') {
            newState.clienteSelecionadoId = programaSelecionado?.cliente_id || '';
        }

        this.setState(newState);
    }

    handleGoAgendamentos = () => {
        window.location.href = `/agendamentos`;
    }

    getDadosRelatorio = async () => {
        let dados_user = getCurrentUser();

        if(hasPerm('view_programas_graficos')) {
            try {
                let cond = '?tipo_usuario='+dados_user['tipo_usuario'];

                if(dados_user['ambiente_programa_id']){
                    cond += "&programa_id="+dados_user['ambiente_programa_id']
                }

                if(dados_user['ambiente_cliente_id']){
                    cond += "&cliente_id="+dados_user['ambiente_cliente_id']
                }

                const response = await api.get(`/atendimentos/relatorio/${cond}`);
                const response_data = response.data

                //Atendimentos agrupados pelo nome do médico no mês atual
                const atendimentos_medicos_mes = response_data.atendimentos_medicos_mes.map(dados => ({
                    id: dados.medico__pessoa__nome,
                    value: dados.quantidade
                }));

                //Atendimentos agrupados por ano do ano atual
                const atendimentos_ano = response_data.atendimentos_ano.map(dados => ({
                    mes: objMeses[dados.data__month],
                    atendimentos: dados.quantidade
                }));

                //Atendimentos agrupados pelo nome do laboratório no mês atual
                const atendimentos_laboratorios_mes = response_data.atendimentos_laboratorios_mes.map(dados => ({
                    id: dados.laboratorio__pessoa__nome,
                    label: dados.laboratorio__pessoa__nome,
                    value: dados.quantidade,
                }));

                const atendimentos_cidades_mes = []
                response_data.atendimentos_cidades_mes.forEach(dados => {
                    let str_cidade = 'Outros'
                    if(dados.beneficiario__cidade){
                        str_cidade = dados.beneficiario__cidade+'/'+dados.beneficiario__uf
                    }

                    atendimentos_cidades_mes.push(
                        {
                            id: str_cidade,
                            label: str_cidade,
                            value: dados.quantidade,
                        }
                    )
                });

                this.setState({
                    atendimentos_medicos_mes: atendimentos_medicos_mes,
                    atendimentos_ano: atendimentos_ano,
                    atendimentos_laboratorios_mes: atendimentos_laboratorios_mes,
                    atendimentos_cidades_mes: atendimentos_cidades_mes,
                    list_titulos_graficos: response_data.list_titulos_graficos,
                })
            } catch (error) {
                console.error('Erro ao carregar dados do relatório:', error);
            }
        }

        if(dados_user['acesso_liberado'] === true && dados_user['ambiente_carteira_id'] && dados_user['ambiente_cliente_id'] && dados_user['ambiente_programa_id']){
            let count =  0 ;
            if (Array.isArray(this.state.list_titulos_graficos)) {
                this.state.list_titulos_graficos.map((r) => {
                    count += 1;
                })
            }
            if(count <= 0){
                window.location.href = '/atendimentos';
                return;
            }
        }
    }

    getExamesMedico = async () => {
        const dados_user = getCurrentUser();

        if (!hasPerm('view_exames')) return;

        try {
            let cond = `?tipo_usuario=${dados_user['tipo_usuario']}&medico_id=${dados_user['prestador_id']}`;
            if (dados_user['ambiente_programa_id']) {
                cond += `&programa_id=${dados_user['ambiente_programa_id']}`;
            }

            const { data } = await api.get(`/exames/solicitados/${cond}`);
            const rows = Array.isArray(data?.results) ? data.results : [];

            // Mapa atendimento_id -> último registro
            const latestByAtd = new Map();

            const getTs = (r) => {
                const a = Date.parse(r?.data_criacao ?? '') || 0;
                const b = Date.parse(r?.dados_exame?.data_recebimento ?? '') || 0;
                // prioriza data_criacao; se empatar, considera maior id
                return [a || b, r?.id || 0];
            };

            for (const r of rows) {
                const atendimentoId = r?.dados_atendimento?.id;
                if (!atendimentoId) continue;

                const curr = latestByAtd.get(atendimentoId);
                if (!curr) {
                    latestByAtd.set(atendimentoId, r);
                    continue;
                }

                const [tsNew, idNew] = getTs(r);
                const [tsOld, idOld] = getTs(curr);

                if (tsNew > tsOld || (tsNew === tsOld && idNew > idOld)) {
                    latestByAtd.set(atendimentoId, r);
                }
            }

            let recusados = 0;
            for (const r of latestByAtd.values()) {
                if (r?.dados_exame?.status === 'recusado') recusados++;
            }

            this.setState({ examesRecusadosCount: recusados });
        } catch (error) {
            console.error('Erro ao carregar dados do relatório:', error);
        }
    };

    async getDashboardsPrograma() {
        try {
            let dados_user = getCurrentUser();
            let programaId = dados_user?.ambiente_programa_id;

            //  fallback automático para admin
            if (!programaId && dados_user.is_superuser) {
                console.warn('Admin sem programa definido — carregando primeiro programa disponível...');
                const resp = await api.get('/programas/?limit=1000');
            if (resp.data.results.length > 0) {
                programaId = 35;
            } else {
                throw new Error('Nenhum programa encontrado no sistema.');
            }
            }

            if (!programaId) throw new Error('Programa ID ausente');

            const response = await api.get(`/programas/${programaId}/`);
            const configuracoes = response.data.configuracoes || {};
            const graficosDashboard = configuracoes.graficos_dashboard || [];

            if (graficosDashboard.length > 0) {
            localStorage.setItem(`programa_tem_dashboard_${programaId}`, 'sim');
            } else {
            localStorage.setItem(`programa_tem_dashboard_${programaId}`, 'nao');
            }

            this.setState({ graficosDashboard, loadingDashboards: false });

        } catch (error) {
            console.error('Erro ao buscar configurações de dashboards do programa:', error);
            this.setState({ loadingDashboards: false });
        }
    }



    render() {
        const dados_user = getCurrentUser();
        const dados_outros = decryptData('o');
        const { dashboard } = this.state;

        //Logomarca do programa
        let cachedLogomarcaTimestamp = '';
        if(dados_user.ambiente_programa_id) {
            cachedLogomarcaTimestamp = localStorage.getItem(`programa_logomarca_${dados_user.ambiente_programa_id}`);
        }

        let logomarca_dashboard = logomarca;
        if(cachedLogomarcaTimestamp) {
            logomarca_dashboard = cachedLogomarcaTimestamp;
        } else if (!dados_user.ambiente_programa_id && this.state.logoPreSelecao) {
            // Pre-selecao (medico escolhendo o ambiente): usa a logo do 1o programa vinculado
            // (ex.: Chiesi -> Cuidados Raros) no lugar da logo do HNS.
            logomarca_dashboard = this.state.logoPreSelecao;
        }

        //Nome do Programa
        let cachedProgramaTimestamp = '';
        if(dados_user.ambiente_programa_id) {
            cachedProgramaTimestamp = localStorage.getItem(`programa_nome_${dados_user.ambiente_programa_id}`);
        }

        let programa_nome = 'Health Navigator System';
        if(cachedProgramaTimestamp) {
            programa_nome = cachedProgramaTimestamp;
        }

        let programa_complemento = '';
        if (programa_nome.includes('PSD')) {
            programa_complemento = 'Programa de Suporte ao Diagnóstico';
        }

        return (
            <>
                {this.state.loadingAmbiente && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255)',
                        zIndex: 1050,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                )}
                <Modal show={this.state.exibirModalPrestador} size="lg">
                    <Modal.Header>
                        <Modal.Title>Ambiente de Acesso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h6 className="mb-4">Escolha abaixo o ambiente que deseja entrar:</h6>
                        <Form.Group controlId="programaSelectPrestador" className="mb-3">
                            <Form.Label>{this.state.nomenclaturaPrograma ? `Escolher ${this.state.nomenclaturaPrograma}` : 'Selecione um Programa'}</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.handleProgramaClienteChange}
                                value={this.state.programaSelecionadoId || ""}
                            >
                                <option value="">{this.state.nomenclaturaPrograma ? `Selecione...` : 'Selecione um programa'}</option>
                                {this.state.programas.map((programa) => (
                                    <option key={programa.value} value={programa.value}>
                                        {programa.label}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        {this.state.clienteSelecionadoId && this.state.programaSelecionadoId && (
                            <Button variant="first" className="mt-2" onClick={() => this.state.prestadorCategoria === 'medicos' ? this.enviarAmbienteMedico() : this.enviarAmbientePrestador()} >
                                Acessar
                            </Button>
                        )}
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.exibirModalGestor} size="lg">
                    <Modal.Header>
                        <Modal.Title>Ambiente de Acesso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h6 className="mb-4">Escolha abaixo o ambiente que deseja entrar:</h6>
                        <Form.Group controlId="clienteSelectGestor" className="mb-3">
                            <Form.Label>Selecione um Cliente</Form.Label>
                            <Form.Control as="select" onChange={this.handleClienteChange}>
                                <option>Selecione um cliente</option>
                                {this.state.clientes.map((cliente) => (
                                    <option key={cliente.value} value={cliente.value}>
                                        {cliente.label}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        {this.state.clienteSelecionadoId && (
                            <Form.Group controlId="programaSelectGestor" className="mb-3">
                                <Form.Label>Selecione um Programa</Form.Label>
                                <Form.Control as="select" onChange={this.handleProgramaClienteChange}>
                                    <option>Selecione um programa</option>
                                    {this.state.programas.map((programa) => (
                                        <option key={programa.value} value={programa.value}>
                                            {programa.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}
                        {this.state.clienteSelecionadoId && this.state.programaSelecionadoId && this.state.clienteSelecionadoId && (
                            <Button variant="first" className="mt-2" onClick={this.enviarAmbienteGestor} >
                                Acessar
                            </Button>
                        )}
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.exibirModalOperador} size="lg">
                    <Modal.Header>
                        <Modal.Title>Ambiente de Acesso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h6 className="mb-4">Escolha abaixo o ambiente que deseja entrar:</h6>
                        <Form.Group controlId="carteiraSelect" className="mb-3">
                            <Form.Label>Selecione uma Carteira </Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.handleCarteiraChange}
                                value={this.state.carteiras.length === 1 ? this.state.carteiras[0].value : undefined}
                                disabled={this.state.carteiras.length === 1}
                            >
                                {this.state.carteiras.length > 1 && <option>Selecione uma carteira</option>}
                                {this.state.carteiras.map((carteira) => (
                                    <option key={carteira.value} value={carteira.value}>
                                        {carteira.label}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        {this.state.carteiraSelecionadaId && (
                            <Form.Group controlId="programaSelect" className="mb-3">
                                <Form.Label>Selecione um Programa</Form.Label>
                                <Form.Control
                                as="select"
                                onChange={this.handleProgramaChange}
                                value={this.state.programas.length === 1 ? this.state.programas[0].value : undefined}
                                disabled={this.state.programas.length === 1}
                                >
                                    {this.state.programas.length > 1 && <option>Selecione um programa</option>}
                                    {this.state.programas.map((programa) => (
                                        <option key={programa.value} value={programa.value}>
                                            {programa.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        )}

                        {this.state.carteiraSelecionadaId && this.state.programaSelecionadoId && this.state.clienteSelecionadoId && (
                            <Button variant="first" className="mt-2" onClick={this.enviarAmbienteOperador} >
                                Acessar
                            </Button>
                        )}
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.exibirModalTipoAcesso} onHide={this.fecharModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Tipo de Acesso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Escolha abaixo o perfil de acesso para continuar usando o sistema:</p>
                        <Form.Select onChange={this.alterarTipoAcesso}>
                            <option value="" key="selecione">Selecione...</option>
                            {
                            Object.keys(tiposAcesso()).map((key, index) => (
                                <option value={key} key={key}>{tiposAcesso()[key]['label']}</option>
                            ))
                            }
                        </Form.Select>
                        <Button variant="first" className="mt-2" onClick={this.enviarTipoAcesso}>
                            Salvar
                        </Button>
                    </Modal.Body>
                </Modal>
                <Row className="mb-5">
                    <Col sm={6} lg={12}>
                        <h2 className={programa_complemento ? `text-white mt-4` : `text-white mt-4 mb-5`}>
                            { programa_nome }
                        </h2>
                        { programa_complemento && (
                            <h5 className="text-white">{programa_complemento}</h5>
                        )}
                    </Col>
                </Row>
                {(dados_outros['acesso_liberado'] === false || dados_user['tipo_usuario'] == 'prestador') ? (
                    <Row className="mt-5 pt-5 justify-content-center">
                        {dados_user.prestador_categoria === 'medicos' && dashboard && dashboard.length > 0 ? (
                            <>
                                <Col xs={12} className="text-center mb-4">
                                    {!this.state.dadosProgramaFallback ? (
                                        <Spinner animation="border" variant="dark" />
                                    ) : (
                                        <>
                                        <img
                                            src={logomarca_dashboard}
                                            className="img-fluid"
                                            alt={programa_nome}
                                        />
                                        </>
                                    )}
                                </Col>

                                {this.state.dadosProgramaFallback && Number(this.state.examesRecusadosCount) > 0 && (
                                    <Col xs={12} className="text-center mb-4">
                                        <Alert variant="warning" className="mt-3 d-inline-block text-start">
                                            <div className="d-flex align-items-center gap-3">
                                                <div>
                                                <h6 className="mb-0"><strong><FaExclamationTriangle /> Atenção!</strong></h6>
                                                Você possui {this.state.examesRecusadosCount}{' '}
                                                {this.state.examesRecusadosCount === 1
                                                    ? 'solicitação de exame recusada.'
                                                    : 'solicitações de exames recusadas.'}
                                                </div>
                                                <div>
                                                <Button
                                                    href="/exames/?status_pedido=recusado"
                                                    variant="outline-dark"
                                                    size="sm"
                                                >
                                                    Ver detalhes
                                                </Button>
                                                </div>
                                            </div>
                                        </Alert>
                                    </Col>
                                )}
                                {// Se for médico e existir dashboard, mapeia e cria 4 colunas
                                dashboard.map(item => (
                                <Col
                                    key={item.id}
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    className="text-center mb-4 d-flex"
                                >
                                    <Card className="cardDestaque flex-fill">
                                        <Card.Body className="d-flex flex-column justify-content-between">
                                        <a href={item.link} className="text-decoration-none d-block">
                                            <div className="dashboard-img-wrapper mb-4 mt-4">
                                            <img
                                                src={item.imagem}
                                                alt={item.titulo}
                                                className="dashboard-img"
                                            />
                                            </div>
                                            <div>
                                            <h4 className="text-dark">{item.titulo}</h4>
                                            </div>
                                        </a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                ))}
                            </>
                        ) : (
                            <Col sm={5} lg={5} className=" mt-5 mb-5">
                                {/* Pre-selecao (medico escolhendo): aguarda a logo do programa (Cuidados Raros)
                                    antes de exibir, pra nao piscar a logo do HNS. Mostra spinner ate o
                                    dadosProgramaFallback (1s, tempo do fetch da logo). So para prestador;
                                    operador/demais veem a logo (HNS) direto. */}
                                {this.state.logoPreSelecaoCarregando ? (
                                    <Spinner animation="border" variant="light" />
                                ) : (
                                    <img className="img-fluid" src={logomarca_dashboard} alt="Aditus" />
                                )}
                            </Col>
                        )}
                    </Row>
                ) : (
                    <>
                        {this.state.superuserSemPrograma && (
                             <>
                                {/* Saudação e Data */}
                                <Row className="mb-3">
                                    <Col>
                                        <h4 className="mb-1" style={{ color: '#1e293b', fontWeight: 600 }}>
                                            {this.getSaudacao()}, {this.getNomeUsuario()}!
                                        </h4>
                                        <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                                            {this.getDataFormatada()}
                                        </p>
                                    </Col>
                                </Row>
                                {/* Layout COMPACTO - quando já tem programa selecionado e dashboards */}
                                {this.state.programaId && this.state.programaNome && this.state.graficosDashboard?.length > 0 ? (
                                    <Row className="mb-4 align-items-center">
                                        <Col xs="auto" className="d-flex align-items-center">
                                            <span
                                                className="d-flex align-items-center justify-content-center me-2"
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    backgroundColor: '#f0f4f8',
                                                    borderRadius: '6px',
                                                    color: '#64748b'
                                                }}
                                            >
                                                <FaChartBar style={{ fontSize: '14px' }} />
                                            </span>
                                            <span className="text-muted me-2" style={{ fontSize: '14px', fontWeight: 500 }}>
                                                Programa:
                                            </span>
                                        </Col>
                                        <Col xs={12} sm={6} md={4} lg={3}>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.programaSearchTimeout);
                                                        this.programaSearchTimeout = setTimeout(() => {
                                                            resolve(this.buscarProgramasComDashboards(inputValue));
                                                        }, 700);
                                                    });
                                                }}
                                                defaultOptions
                                                onChange={this.handleProgramaSuperuserChange}
                                                placeholder="Trocar programa..."
                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                isClearable={false}
                                                loadingMessage={() => "Buscando..."}
                                                value={{ value: this.state.programaId, label: this.state.programaNome }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '38px',
                                                        borderColor: '#dee2e6',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#86b7fe' }
                                                    }),
                                                    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                                    input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                                    indicatorSeparator: () => ({ display: 'none' }),
                                                    dropdownIndicator: (base) => ({ ...base, padding: '6px' })
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                ) : (
                                    /* Layout CARD GRANDE - quando não tem programa selecionado */
                                    <Card
                                        className="border-0 shadow-sm mb-4 mt-4"
                                        style={{ borderRadius: '12px' }}
                                    >
                                        <Card.Body className="p-4 p-md-4">
                                            {/* Seção de seleção */}
                                            <div className="d-flex align-items-start mb-4">
                                                <div
                                                    className="d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                                                    style={{
                                                        width: '48px',
                                                        height: '48px',
                                                        backgroundColor: '#eef2ff',
                                                        borderRadius: '10px'
                                                    }}
                                                >
                                                    <FaChartLine style={{ fontSize: '22px', color: '#6366f1' }} />
                                                </div>
                                                <div>
                                                    <h6 className="mb-1" style={{ color: '#1e293b', fontWeight: 600 }}>
                                                        Selecione um Programa
                                                    </h6>
                                                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                                                        Escolha um programa abaixo para visualizar os indicadores detalhados
                                                    </p>
                                                </div>
                                            </div>

                                            {this.state.loadingProgramasSuperuser ? (
                                                <div className="py-4">
                                                    <Spinner animation="border" variant="primary" size="sm" />
                                                    <span className="text-muted ms-2">Carregando programas...</span>
                                                </div>
                                            ) : (
                                                <Form.Group controlId="programaSuperuserSelect">
                                                    <AsyncSelect
                                                        cacheOptions
                                                        loadOptions={(inputValue) => {
                                                            return new Promise((resolve) => {
                                                                clearTimeout(this.programaSearchTimeout);
                                                                this.programaSearchTimeout = setTimeout(() => {
                                                                    resolve(this.buscarProgramasComDashboards(inputValue));
                                                                }, 700);
                                                            });
                                                        }}
                                                        defaultOptions
                                                        onChange={this.handleProgramaSuperuserChange}
                                                        placeholder="Clique para selecionar um programa..."
                                                        noOptionsMessage={() => "Nenhum programa com dashboards encontrado"}
                                                        isClearable
                                                        loadingMessage={() => "Buscando programas..."}
                                                        value={this.state.programaId ? { value: this.state.programaId, label: this.state.programaNome || 'Programa Selecionado' } : null}
                                                        styles={{
                                                            control: (base, state) => ({
                                                                ...base,
                                                                minHeight: '50px',
                                                                borderColor: state.isFocused ? '#6366f1' : '#e2e8f0',
                                                                boxShadow: state.isFocused ? '0 0 0 3px rgba(99, 102, 241, 0.1)' : 'none',
                                                                borderRadius: '10px',
                                                                '&:hover': { borderColor: '#6366f1' }
                                                            }),
                                                            placeholder: (base) => ({ ...base, color: '#94a3b8' }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                borderRadius: '10px',
                                                                boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                                                            }),
                                                            option: (base, state) => ({
                                                                ...base,
                                                                backgroundColor: state.isSelected ? '#6366f1' : state.isFocused ? '#eef2ff' : 'white',
                                                                color: state.isSelected ? 'white' : '#1e293b',
                                                                padding: '12px 16px'
                                                            })
                                                        }}
                                                    />
                                                    <div className="mt-3">
                                                        <small className="text-muted">
                                                            <FaChevronDown className="me-1" />
                                                            Os indicadores aparecerão abaixo após a seleção
                                                        </small>
                                                    </div>
                                                </Form.Group>
                                            )}
                                        </Card.Body>
                                    </Card>
                                )}
                            </>
                        )}

                        {this.state.loadingDashboardsConfig ? (
                            <Row className="mt-3">
                                <Col lg={12} className="text-center">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="text-muted mt-2">Carregando dashboards...</p>
                                </Col>
                            </Row>
                        ) : (
                            <Row className="mt-3">
                                {this.renderDashboards()}
                            </Row>
                        )}
                    </>
                )}
            </>
        );
    }
}

export default withRouter(Home);
